import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-200">
          <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
        </div>
        <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-foreground-600">您访问的页面不存在或已被移除。</p>
        <Link
          to="/"
          className="inline-flex items-center mt-6 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
        >
          <i className="ri-arrow-left-line mr-2"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}